import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NavbarProfile from '../components/profileContent/NavbarProfile';
import ProfileInfo from '../components/profileContent/ProfileInfo'
import Container from '@material-ui/core/Container'

const useStyles = makeStyles(theme => ({
    root: {
        // height: '100%'
    }
}))

const Profile = ({ contentRef }) => {
    const classes = useStyles()

    return (
        <div className={classes.root} ref={contentRef}>
            <NavbarProfile />
            <Container maxWidth="xl"  >
                <ProfileInfo />
            </Container>
        </div>
    )
}

export default Profile
